import React from "react"
import {FieldGlistGroupProps} from "../../../render/glist/glist-group";


export default function FieldProto_GlistGroupStandard(props:FieldGlistGroupProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.glistGroupStandard</div>
    )

}
